import { ColCatService } from '../../shop/services/col-cat.service';
import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Currency } from '../../shop/interfaces/currency';
import { NavService } from '../../shop/services/nav.service';
import { PricesService } from '../../shop/services/prices.service';
import { Subscription } from 'rxjs';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-nav',
  styleUrls: ['./nav.component.scss'],
  templateUrl: './nav.component.html'
})

export class NavComponent implements OnDestroy, OnInit {

  private collections: any[];
  private exchangeRate: string[];
  private search = false;
  private key: string;
  private subCollections: any[];
  private subOptions = false;
  private subscription: Subscription;

  public categories: any[];
  public status = false;
  public subCategories: any[];

  constructor(
    private colCatService: ColCatService,
    private navState: NavService,
    private pricesService: PricesService
  ) {
    this.subscription = this.navState.getStatus().subscribe(status => this.status = status);
  }

  ngOnInit(): void {
    this.subscription =
      // this.colCatService.getCollections().subscribe(data => this.collections = data),
      // this.colCatService.subCollection().subscribe(data => this.subCollections = data),
      this.colCatService.category().subscribe(data => this.categories = data),
      this.colCatService.subCategory().subscribe(data => this.subCategories = data);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('keydown', ['$event'])handleKeyboardEvent(event: KeyboardEvent) {
    this.key = event.key;
    if (this.key === 'Escape') {
      if (this.status = true) {
        this.status = false;
      }
    }
  }

  public clickedInside($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    console.log('Inside menu click event detected');
  }

  private getKeys(obj): any {
    return Object.keys(obj);
  }

  private getSelect(currency: string): void {
    this.pricesService.parseJSON(currency);
    if (currency !== 'ZAR') {
      this.pricesService.isZAR = false;
    } else {
      this.pricesService.isZAR = true;
    }
  }

  private openChild(event) {
    const ul = document.querySelectorAll('ul');
    const id = event.srcElement.id;

    for (let i = 0; i < ul.length; i++) {
      ul[i].classList.add('hide-li');
      if (ul[i].dataset.indexNumber === id) {
        if (ul[i].classList.contains('hide-li')) {
          ul[i].classList.remove('hide-li');
        } else {
          ul[i].classList.add('hide-li');
        }
      }
    }
  }

  private updateCurrency(currency: Currency): void {
    this.pricesService.updateCurrency(currency);
  }

  private toggleCart(): void {
    this.navState.openNav(true);
    this.status = !this.status;
  }

  private toggleSearch(): void {
    this.search = !this.search;
  }

  private toggleSubscribe(): void {
    this.subOptions = !this.subOptions;
  }

  public toggleMenu(): void {
    this.status = !this.status;
  }
}
